<template>
  <div
    v-if="isShowBindPhone"
    class="bind-phone-box show-flex-box-c show-flex-center"
    @click.self="colseBindPhonePop()"
  >
    <div class="bind-phone-total show-flex-box-r show-flex-center">
      <div class="bind-phone-all show-flex-box-c">
        <em @click.self="colseBindPhonePop()"></em>
        <dl>
          <dt class="bind-phone-title">
            <h3>{{bindTypeTitle}}</h3>
          </dt>
          <dd class="bind-phone-input show-flex-box-c show-flex-center">
            <h3 class="show-flex-box-c">
              <strong>{{typeName}}</strong>
              <span class="show-flex-box-r">
                <input type="text" :placeholder="placeholder" v-model="telNumberOrEmail" />
                <strong style="color:rgba(193,190,190,1);" v-if="countDownStatus">{{remainCount}}s</strong>
                <em v-if="!countDownStatus" @click="!countDownStatus && clickToSendAuthCode()">获取验证码</em>
              </span>
            </h3>
            <h3 class="show-flex-box-c">
              <strong>验证码</strong>
              <span class="show-flex-box-r">
                <input type="text" placeholder="请输入验证码" v-model="verificationCode" />
              </span>
            </h3>
          </dd>
          <dd class="bind-phone-next-botton show-flex-box-r show-flex-center">
            <span @click="sureBindInfor()">绑定</span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import regex from "@/filter/regex";
import { CountDown } from "@/../static/js/CountDown";

export default {
  name: "login",
  data() {
    return {
      // ShowCodeOrTime: true,
      bindTypeTitle: "绑定手机号",
      placeholder: "请输入手机号",
      typeName: "手机号",
      isShowBindPhone: false,
      pageType: "",
      telNumberOrEmail: "",
      verificationCode: "",
      countDownStatus: false,
      counter: null,
      remainCount: ""
    };
  },
  props: {
    bindParams: [Object]
  },
  inject: ["reload"],
  methods: {
    colseBindPhonePop: function(type) {
      this.isShowBindPhone = !this.isShowBindPhone;
      if (this.isShowBindPhone) {
        this.initCountDown();
      } else {
        this.$router.back(-1);
      }

      this.selectBindType(type);
    },
    sureBindInfor: function() {
      var params = {
        verify_code: this.verificationCode,
        unionid: this.bindParams && this.bindParams.unionid,
        type: this.bindParams && this.bindParams.type
      };
      if (this.pageType == "bindPhone") {
        params.phone = this.telNumberOrEmail;
      } else {
        params.email = this.telNumberOrEmail;
      }

      this.$client
        .socialBind(params)
        .then(res => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "绑定成功",
              type: "success"
            });
            this.isShowBindPhone = false;
            var token = res.data.token;
            var saveTokenObj = {
              token: res.data.token
            };
            this.$store.commit("SET_TOKEN", saveTokenObj);
            this.$store.commit("LOGIN", true); //登录成功后改变登录状态
            if (!res.data.user.has_password) {
              this.$emit("open-set-password-pop", false);
            } else {
              this.$router.push({ path: "/web/index" });
              this.reload();
            }
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.data.message,
            type: "error"
          });
        });
    },

    selectBindType: function(type) {
      this.pageType = type;

      if (type == "bindPhone") {
        this.bindTypeTitle = "绑定手机号";
        this.typeName = "手机号";
        this.placeholder = "请输入手机号";
      } else {
        this.bindTypeTitle = "绑定邮箱";
        this.typeName = "邮箱";
        this.placeholder = "请输入邮箱";
      }
    },
    initCountDown: function() {
      var _this = this;

      this.counter = new CountDown(60, function(cnt) {
        if (0 === cnt) {
          _this.clearCounterWithCount();
        } else {
          _this.remainCount = cnt;
        }
      });
    },
    clearCounterWithCount: function() {
      this.counter && this.counter.cancel();
      this.countDownStatus = false;
    },
    clickToSendAuthCode: function(count) {
      var allowSendStatus = this.checkCanVerify();

      if (allowSendStatus) {
        this.sendMessage();
      }
    },
    checkCanVerify: function() {
      var status = true;
      if (this.pageType == "bindPhone") {
        if (regex.isEmpty(this.telNumberOrEmail)) {
          this.$message({
            showClose: true,
            message: "请输入手机号",
            type: "error"
          });
          return false;
        } else {
          if (regex.isPhoneNumber(this.telNumberOrEmail)) {
            return true;
          } else {
            this.$message({
              showClose: true,
              message: "请输入正确的手机号码格式",
              type: "error"
            });
            return false;
          }
        }
      } else {
        if (regex.isEmpty(this.telNumberOrEmail)) {
          this.$message({
            showClose: true,
            message: "请输入邮箱",
            type: "error"
          });
          return false;
        } else {
          if (regex.isEmail(this.telNumberOrEmail)) {
            return true;
          } else {
            this.$message({
              showClose: true,
              message: "请输入正确的邮箱格式",
              type: "error"
            });
            return false;
          }
        }
      }
    },
    sendMessage: function() {
      var _this = this;
      var params = {
        account: this.telNumberOrEmail,
        type: "bind_social"
      };

      if (this.pageType == "bindPhone") {
        params.way = "phone";
      } else {
        params.way = "email";
      }

      this.$client
        .sendVerifyCode(params)
        .then(res => {
          var code = res.code + "";

          if (code == "200") {
            _this.$message({
              showClose: true,
              message: "验证码发送成功",
              type: "success"
            });

            _this.countDownStatus = true;
            _this.counter.start();
          }
        })
        .catch(err => {
          _this.clearCounterWithCount();

          if (err.data && err.data.message) {
            _this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          }
        });
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
.bind-phone-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  .bind-phone-total {
    position: absolute;
    width: 553px;
    height: 430px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    .bind-phone-all {
      width: 489px;
      height: 390px;
      align-items: flex-end;
      & > em {
        width: 22px;
        height: 22px;
        background: url("../../../assets/login/close_arrow_icon.png") no-repeat
          center center;
        background-size: 22px 22px;
        cursor: pointer;
      }
      & > dl {
        width: 513px;
        margin-top: 8px;
        .bind-phone-title {
          width: 100%;
          & > h3 {
            width: 100%;
            text-align: center;
            height: 21px;
            font-size: 15px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: rgba(48, 41, 41, 1);
            line-height: 21px;
          }
        }
        .bind-phone-input {
          width: 100%;
          margin-top: 40px;
          & > h3 {
            width: 393px;
            margin-bottom: 20px;
            & > strong {
              height: 21px;
              font-size: 15px;
              font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
              font-weight: 600;
              color: rgba(48, 41, 41, 1);
              line-height: 21px;
              margin-bottom: 6px;
            }
            & > span {
              width: 363px;
              height: 52px;
              border: 1px solid rgba(221, 221, 221, 1);
              padding: 0px 15px;
              justify-content: space-between;
              align-items: center;
              flex-shrink: 1;
              & > input {
                display: block;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                flex-grow: 1;
              }
              & > em {
                height: 19px;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(230, 0, 18, 1);
                line-height: 19px;
                flex-shrink: 1;
                cursor: pointer;
              }
              & > strong {
                height: 19px;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(193, 190, 190, 1);
                line-height: 19px;
              }
            }
          }
        }
        .bind-phone-next-botton {
          margin-top: 20px;
          width: 100%;
          & > span {
            width: 393px;
            height: 52px;
            background: rgba(48, 41, 41, 1);
            text-align: center;
            line-height: 52px;
            font-size: 15px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pop/my/social_bind_phone_cpn.vue